import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { BuscarCiudadModel } from "../buscar-ciudad/buscar-ciudad.model";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { DireccioneModel, IDireccion } from "../../models/general/cliente.model";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../control-core/util/waitme.util";
import { notify, SUCCESS_NOTIFY } from "../../../control-core/util/notify.util";
import Swal from 'sweetalert2'
import { ErrorService } from "../../../control-core/services/error.service";
import { CiudadModel, DepartamentoModel, PaisModel } from "../../models/general/gestion-geografica.model";
import { BuscarCiudadComponent } from "../buscar-ciudad/buscar-ciudad.component";

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-direccion-user',
  templateUrl: './direccion-user.component.html'
})
export class DireccionUserComponent implements OnInit {

  @ViewChild(BuscarCiudadComponent) child: BuscarCiudadComponent;

  @Input() isUpdateDireccion: boolean;
  @Input() objDireccion: DireccioneModel = new DireccioneModel();
  @Input() ciudad: BuscarCiudadModel;
  @Output() onCompletado: EventEmitter<{ success: boolean, msg: any }> = new EventEmitter();

  buscarCiudad = {hasError: false, errorText: ""};

  public confirmaActu = this._translate.instant('CONFIR_UPDATE_DATA_LABEL');
  public confirmaCreacion = this._translate.instant('CONFIR_REGIST_DATA_LABEL');
  public _YES_LABEL = this._translate.instant('YES_LABEL');
  public _NO_LABEL = this._translate.instant('NO_LABEL');
  campoRequerido = this._translate.instant("FIELD_REQUIRED");


  edicionDireccion = this._translate.instant('EDICION_DIRECCION_LABEL');
  nuevaDireccion = this._translate.instant('NUEVA_DIRECCION_LABEL');

  objectDireccionError = {
    zipError: false,
    direccionError: false,
    zipText: this.campoRequerido,
    direccionText: this.campoRequerido
  };

  constructor( private _http: HttpClient,
               private _translate: TranslateService,
               private _errorService: ErrorService) {
  }

  ngOnInit() {
  }

  updateDireccion() {
    if (this.checkDireccionData()) {
      return false;
    }

    let dataUpdate = {
      direccion_id: this.objDireccion.id,
      direccion: this.objDireccion.direccion,
      ciudad_id: this.objDireccion.geciudade_id,
      principal: this.objDireccion.principal,
      zip: this.objDireccion.zip
    };

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaActu + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        if (this.ciudad.ciudad_id != null && this.ciudad.ciudad_id != this.objDireccion.geciudade_id) {
          dataUpdate.ciudad_id = this.ciudad.ciudad_id;
          this.objDireccion.ciudad = this.ciudad.ciudad;
          this.objDireccion.ciudad.departamento = this.ciudad.estado;
          this.objDireccion.ciudad.departamento.pais = this.ciudad.pais;
        }

        this._http.put<any>(`${CONTROL_APP_CONST.API_URL}updateDirecciones`, dataUpdate)
            .subscribe(
                (response) => {

                  notify(this._translate.instant(response), SUCCESS_NOTIFY);
                  this.onCompletado.emit({success: true, msg: ''});
                }, (error) => {

                  this._errorService.manejaError(error);
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#edicionDireccionModalContent');
      }
    });
  }

  addDireccion() {
    if (this.checkDireccionData()) {
      return false;
    }

    let dataNewDireccion = {
      direccion: this.objDireccion.direccion,
      ciudad_id: this.objDireccion.geciudade_id,
      zip: this.objDireccion.zip
    };

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaCreacion + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        if (this.ciudad.ciudad_id != null && this.ciudad.ciudad_id != this.objDireccion.geciudade_id) {
          dataNewDireccion.ciudad_id = this.ciudad.ciudad_id;
          this.objDireccion.ciudad = this.ciudad.ciudad;
          this.objDireccion.ciudad.departamento = this.ciudad.estado;
          this.objDireccion.ciudad.departamento.pais = this.ciudad.pais;
        }

        this._http.post<IDireccion>(`${CONTROL_APP_CONST.API_URL}addDireccion`, dataNewDireccion)
            .subscribe(
                (response) => {

                  notify(this._translate.instant('NEW_DIR_ADDED_LABEL'), SUCCESS_NOTIFY);
                  this.onCompletado.emit({success: true, msg: ''});
                }, (error) => {

                  this._errorService.manejaError(error);
                }
            )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#edicionDireccionModalContent');
      }
    });

  }

  checkDireccionData() {
    let x = 0;

    this.objectDireccionError.zipError = false;
    this.objectDireccionError.direccionError = false;
    this.buscarCiudad = {hasError: false, errorText: ""};

    if (!this.ciudad.ciudad_id) {
      this.buscarCiudad.hasError = true;
      this.buscarCiudad.errorText = this.campoRequerido;
      x++;
    }

    if (this.objDireccion.zip == '') {
      this.objectDireccionError.zipError = true;
      x++;
    }

    if (this.objDireccion.direccion == '') {
      this.objectDireccionError.direccionError = true;
      x++;
    }

    return x > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/control-app/shared/direccion-user/direccion-user.component.ts